import Cookies from 'js-cookie'
import { PROVIDERS } from 'constants/keys'

// Key name
const TOKEN_KEY = '2670391282ae79f7692be09385910acd'
const SOCIAL_TOKEN_KEY = 'dec47fd8a4f9499d85a1078528412277'
const REFERRER_KEY = 'referrer'

/**
 * Remove lessor access token
 */
export const removeToken = () => {
  return Cookies.remove(TOKEN_KEY)
}

/**
 * Get access token
 *
 * @returns {String}
 */
export const getToken = (remove = false) => {
  const token = Cookies.get(TOKEN_KEY)

  if (remove) {
    removeToken()
  }

  return token
}

/**
 * Set access token
 *
 * @param {String} token
 */
export const setToken = (token) => {
  return Cookies.set(TOKEN_KEY, token)
}

/**
 * Check if given key is token key
 *
 * @param {String} key
 */
export const isTokenKey = (key) => {
  return key === TOKEN_KEY
}

/**
 * Resolve akamain endpoint
 *
 * @param {String} provider
 * @param {Boolean} merge
 * @return {String}
 */
export const resolveAkamaiUrl = (provider, merge = false) => {
  // Redirect url
  const redirectUrl = new URL(
    '/user/social-login/callback',
    window.location.origin
  )
  if (merge) {
    redirectUrl.searchParams.append('merge', true)
  }

  // Akamai url
  const config = PROVIDERS.find((x) => x.provider === provider)

  if (config) {
    const akamaiUrl = new URL(config.akamai)
    akamaiUrl.searchParams.append('language_preference', 'en')
    akamaiUrl.searchParams.append('token_url', redirectUrl.toString())

    return akamaiUrl.toString()
  }

  return null
}

/**
 * Set social token
 *
 * @param {String} token
 */
export const setSocialToken = (token) => {
  return Cookies.set(SOCIAL_TOKEN_KEY, token)
}

/**
 * Get social token
 *
 * @returns {String}
 */
export const getSocialToken = () => {
  return Cookies.get(SOCIAL_TOKEN_KEY)
}

/**
 * Remove social token
 */
export const removeSocialToken = () => {
  return Cookies.remove(SOCIAL_TOKEN_KEY)
}

/**
 * Set referrer
 *
 * @param {String} token
 */
export const setReferrer = (value) => {
  return Cookies.set(REFERRER_KEY, value)
}

/**
 * Get referrer
 *
 * @returns {String}
 */
export const getReferrer = () => {
  return Cookies.get(REFERRER_KEY)
}

/**
 * Remove referrer
 */
export const removeReferrer = () => {
  return Cookies.remove(REFERRER_KEY)
}
